var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#273943",
    fillRule: "evenodd",
    d: "M8 1.25c.126 0 .245.031.349.086l7.627 3.814 6.652-3.801A.75.75 0 0 1 23.75 2v16a.75.75 0 0 1-.378.651l-6.988 3.994a.747.747 0 0 1-.377.105h-.009.01m-.357-.086L8.024 18.85l-6.652 3.801A.75.75 0 0 1 .25 22V6a.75.75 0 0 1 .378-.651l6.988-3.994A.746.746 0 0 1 8 1.25m8.75 19.458 5.5-3.143V3.292l-5.5 3.143v14.273Zm-1.5-14.244v14.322l-6.5-3.25V3.215l6.5 3.25Zm-13.5-.029 5.5-3.143v14.273l-5.5 3.143V6.435Z",
    clipRule: "evenodd"
  })));
};
export default SvgMap;